import { z } from 'zod';

export const CustomerForAnalyticsSchema = z.object({ created_at: z.string(), notifications_allowed: z.boolean() });
export type CustomerForAnalytics = z.infer<typeof CustomerForAnalyticsSchema>;
